module.exports = __webpack_public_path__ + "static/media/LogoNature.21a62d60.svg";